import IshaChat from '../components/IshaChat';

export default function HelpCenterPage() {
  const faqs = [
    {
      q: 'How do I upload a CT scan?',
      a: 'Navigate to the Lung Cancer page, click "Choose NIfTI File" or drag-and-drop a .nii/.nii.gz file into the upload area, then click "Upload & Analyze".',
    },
    {
      q: 'What file formats are supported?',
      a: 'For lung cancer detection, NIfTI (.nii, .nii.gz) files are supported. Other cancer modules accept standard image formats (PNG, JPEG, TIFF).',
    },
    {
      q: 'How long does analysis take?',
      a: 'Lung CT analysis typically takes 2–5 minutes depending on scan size. The GPU instance starts on-demand and processes the scan automatically.',
    },
    {
      q: 'What does the confidence score mean?',
      a: 'The confidence score represents the model\'s certainty about its prediction, ranging from 0% to 100%. Higher values indicate greater certainty.',
    },
    {
      q: 'Is my data secure?',
      a: 'All data is encrypted in transit (TLS) and at rest (S3 server-side encryption). Scans are stored temporarily and deleted after processing unless you choose to keep them.',
    },
    {
      q: 'Who is Isha?',
      a: 'Isha is the CancePro AI assistant. Click the "Ask Isha" button at the bottom-right corner of any page to chat about cancer detection, your results, or general questions.',
    },
  ];

  return (
    <>
      <h1 className="h3 mb-3"><strong>Help</strong> Center</h1>

      <div className="row">
        <div className="col-lg-8">
          {/* FAQ */}
          <div className="card mb-3">
            <div className="card-header">
              <h5 className="card-title mb-0">Frequently Asked Questions</h5>
            </div>
            <div className="card-body">
              <div className="accordion" id="faqAccordion">
                {faqs.map((faq, i) => (
                  <div className="accordion-item" key={i}>
                    <h2 className="accordion-header" id={`faqH${i}`}>
                      <button
                        className={`accordion-button${i === 0 ? '' : ' collapsed'}`}
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={`#faqC${i}`}
                        aria-expanded={i === 0 ? 'true' : 'false'}
                        aria-controls={`faqC${i}`}
                      >
                        {faq.q}
                      </button>
                    </h2>
                    <div
                      id={`faqC${i}`}
                      className={`accordion-collapse collapse${i === 0 ? ' show' : ''}`}
                      aria-labelledby={`faqH${i}`}
                      data-bs-parent="#faqAccordion"
                    >
                      <div className="accordion-body">{faq.a}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Getting Started */}
          <div className="card mb-3">
            <div className="card-header">
              <h5 className="card-title mb-0">Getting Started</h5>
            </div>
            <div className="card-body">
              <ol className="mb-0">
                <li className="mb-2">Select a cancer type from the sidebar.</li>
                <li className="mb-2">Upload your medical image or CT scan.</li>
                <li className="mb-2">Wait for the AI model to analyze the data.</li>
                <li className="mb-2">Review results, confidence scores, and overlays.</li>
                <li>Download or share your report as needed.</li>
              </ol>
            </div>
          </div>
        </div>

        <div className="col-lg-4">
          {/* Contact */}
          <div className="card mb-3">
            <div className="card-header">
              <h5 className="card-title mb-0">Contact Support</h5>
            </div>
            <div className="card-body">
              <p className="text-muted">Need more help? Reach out to the CancePro support team.</p>
              <ul className="list-unstyled mb-0">
                <li className="mb-2"><strong>Email:</strong> support@cancepro.com</li>
                <li className="mb-2"><strong>Response Time:</strong> Within 24 hours</li>
              </ul>
              <hr />
              <p className="text-muted mb-0">
                Or use <strong>Ask Isha</strong> for instant AI-powered assistance.
              </p>
            </div>
          </div>

          {/* System Info */}
          <div className="card mb-3">
            <div className="card-header">
              <h5 className="card-title mb-0">System Information</h5>
            </div>
            <div className="card-body">
              <ul className="list-unstyled mb-0">
                <li className="mb-1"><strong>Platform:</strong> CancePro Med-X</li>
                <li className="mb-1"><strong>Model:</strong> ResAttUNet</li>
                <li className="mb-1"><strong>Backend:</strong> AWS (Lambda + EC2 GPU)</li>
                <li className="mb-1"><strong>Region:</strong> us-east-1</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <IshaChat />
    </>
  );
}
